/**
 * Created by DSadler on 25/04/2017.
 */
import React, {Component} from 'react';
import ToolBox from "./ToolBox";
import {connect} from "react-redux";
import {setUiToolboxActiveTab, setUiToolboxPinned, setUiToolboxVisibility} from "../../../state/ui/actions";
import {getUiToolboxActiveTab, getUiToolboxPinned, getUiToolboxVisibility} from "../../../state/ui/selectors";

class ToolBoxContainer extends Component {
  constructor(props) {
    super(props);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePin = this.handlePin.bind(this);
    this.handleUnpin = this.handleUnpin.bind(this);
    this.handleChangeTab = this.handleChangeTab.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
  }
  
  handleOpen() {
    this.props.dispatch(setUiToolboxVisibility(true));
  };
  handleClose() {
    this.props.dispatch(setUiToolboxVisibility(false));
  };
  handlePin() {
    this.props.dispatch(setUiToolboxPinned(true));
  };
  handleUnpin() {
    this.props.dispatch(setUiToolboxPinned(false));
  };
  handleChangeTab(tab) {
    this.props.dispatch(setUiToolboxActiveTab(tab));
  };
  handleOnClick(e) {
    e.preventDefault();
    e.stopPropagation();
  };
  
  render() {
    return (
      <ToolBox
        visible={this.props.toolbarVisible}
        pinned={this.props.toolbarPinned}
        tab={this.props.activeTab}
        changeTab={this.handleChangeTab}
        show={this.handleOpen}
        hide={this.handleClose}
        pin={this.handlePin}
        unpin={this.handleUnpin}
        click={this.handleOnClick}
      />
    );
  }
}

function mapStateToProps(state) {
  let toolbarVisible = getUiToolboxVisibility(state);
  let toolbarPinned = getUiToolboxPinned(state);
  let activeTab = getUiToolboxActiveTab(state);
  
  return {
    toolbarVisible,
    toolbarPinned,
    activeTab,
  };
}

function mapDispatchToProps(dispatch) {
  return {dispatch};
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolBoxContainer);


// WEBPACK FOOTER //
// ./src/App/Editor/components/ui/ToolBox/ToolBoxContainer.js